import { supabase } from "@/integrations/supabase/client";
import { readDeliveryChain, resolveOwnWriteBack } from "@/write-back/deliveryChain";
import { useQuery } from "@tanstack/react-query";

export const useWriteBackResult = (reviewId: string, encounterId: string) =>
  useQuery({
    queryKey: ["write-back-result", encounterId, reviewId],
    queryFn: async () => {
      // A chain can cross reviews, so this review's own rows can show several apparent heads.
      const { data, error } = await supabase
        .from("outbound_result_write_backs")
        .select("*")
        .eq("encounter_id", encounterId);
      if (error) throw error;

      return resolveOwnWriteBack(readDeliveryChain(data ?? []), (row) => row.human_review_id === reviewId);
    },
  });
